export default function alwaysZero(): 0 {
  return 0
}